import React, { useCallback, useEffect, useState } from "react";
import api from "../../utils/axiosInstance";
import { getApiErrorMessage } from "../../utils/errorMessages";
import CheckoutRecoveryState from "./CheckoutRecoveryState";

export default function CustomerCheckoutRecovery() {
  const [page, setPage] = useState(1);
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const load = useCallback(async () => {
    setBusy(true); setError("");
    try { setData((await api.get("/orders/checkouts", { params: { page } })).data); }
    catch (err) { setError(getApiErrorMessage(err, { fallback: "Payment reviews could not be loaded." })); }
    finally { setBusy(false); }
  }, [page]);
  useEffect(() => { load(); }, [load]);
  if (!data?.checkouts?.length && !error) return null;
  return <section aria-label="Checkout payment reviews">
    <h2>Checkout payments</h2>
    {data?.checkouts?.map((checkout) => <CheckoutRecoveryState key={checkout.checkoutReference} checkout={checkout} onRefresh={load} busy={busy} />)}
    {error ? <p role="alert">{error}</p> : null}
    {data?.pages > 1 ? <nav aria-label="Payment review pages"><button type="button" disabled={busy || page === 1} onClick={() => setPage(page - 1)}>Previous</button><span>Page {page} of {data.pages}</span><button type="button" disabled={busy || page >= data.pages} onClick={() => setPage(page + 1)}>Next</button></nav> : null}
  </section>;
}
